import { Action, createReducer, on } from '@ngrx/store';

import { initialState, EntityRolState } from './entity-roles.state';
import { entityRolAdapter } from './entity-roles.state';
import {
  entityRolAddFailure,
  entityRolAddRequest,
  entityRolAddSuccess,
  entityRolChangeFailure,
  entityRolChangeRequest,
  entityRolChangeSuccess,
  entityRolDeleteFailure,
  entityRolDeleteRequest,
  entityRolDeleteSuccess,
  entityRolLoadFailure,
  entityRolLoadRequest,
  entityRolLoadSuccess
} from './entity-roles.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityRolLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityRolLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityRolLoadSuccess, (state, { items }) =>
    entityRolAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // add
  on(entityRolAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityRolAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityRolAddSuccess, (state, { item }) =>
    entityRolAdapter.addOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // change
  on(entityRolChangeRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityRolChangeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityRolChangeSuccess, (state, { item }) =>
    entityRolAdapter.upsertOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // delete
  on(entityRolDeleteRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityRolDeleteFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityRolDeleteSuccess, (state, { item }) =>
    entityRolAdapter.removeOne(item.id, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function rolReducer(state: EntityRolState | undefined, action: Action) {
  return reducer(state, action);
}
